import { useMutation, useQuery } from 'react-query';

import { FormActions, NotificationPosition } from 'coreOld/enums';
import { useHandleErrors, useInfiniteQuery } from 'coreOld/hooks';
import { actionLoadingMessage, actionMessage } from 'coreOld/utils';
import { pricingService } from 'partsOld/services';
import { IPricing } from 'partsOld/types';

export const useGetPricingList = (filters?) =>
  useInfiniteQuery<IPricing>(pricingService.getMany, 'pricingList', filters);

export const useGetActiveOverlappingPrice = (queryParams?) => {
  const { data, isError, isLoading, refetch } = useQuery(
    ['activeOverlappingPrice', queryParams],
    () => pricingService.getActiveOverlappingPrice(queryParams),
    {
      keepPreviousData: true,
      enabled: false,
    }
  );

  return {
    record: data?.record ?? null,
    isError,
    isLoading,
    refetch,
  };
};

export const usePricingActions = () => ({
  ...useUpsertPrice(),
  ...useRemovePrice(),
});

const useUpsertPrice = () => {
  const { errors } = useHandleErrors(
    actionMessage('Part price'),
    actionLoadingMessage('part price'),
    NotificationPosition.MODAL,
    ['pricingList'],
    FormActions.UPSERT
  );
  const { mutateAsync } = useMutation(pricingService.upsertPrice, {
    ...errors,
  });

  const upsertPrice = (data) => mutateAsync(data);

  return { upsertPrice };
};

const useRemovePrice = () => {
  const { errors } = useHandleErrors(
    actionMessage('Part price'),
    actionLoadingMessage('part price'),
    NotificationPosition.MODAL,
    ['pricingList'],
    FormActions.REMOVE
  );

  const { mutateAsync, isLoading, isSuccess } = useMutation(pricingService.removePrice, {
    ...errors,
  });

  const removePrice = (data) => mutateAsync(data);

  return { removePrice, isLoading, isSuccess };
};
